var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91667 1.5C2.13426 1.5 1.5 2.13426 1.5 2.91667V19.5833C1.5 20.3657 2.13426 21 2.91667 21H19.5833C20.3657 21 21 20.3657 21 19.5833V2.91667C21 2.13426 20.3657 1.5 19.5833 1.5H2.91667ZM0 2.91667C0 1.30584 1.30584 0 2.91667 0H19.5833C21.1942 0 22.5 1.30584 22.5 2.91667V19.5833C22.5 21.1942 21.1942 22.5 19.5833 22.5H2.91667C1.30584 22.5 0 21.1942 0 19.5833V2.91667ZM11.25 6C11.6642 6 12 6.33579 12 6.75V10.5H15.75C16.1642 10.5 16.5 10.8358 16.5 11.25C16.5 11.6642 16.1642 12 15.75 12H12V15.75C12 16.1642 11.6642 16.5 11.25 16.5C10.8358 16.5 10.5 16.1642 10.5 15.75V12H6.75C6.33579 12 6 11.6642 6 11.25C6 10.8358 6.33579 10.5 6.75 10.5H10.5V6.75C10.5 6.33579 10.8358 6 11.25 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSquare);
export default __webpack_public_path__ + "static/media/new-square.00e4926ff95ea19427eeccb80d994a5a.svg";
export { ForwardRef as ReactComponent };